export const TOGGLE_ARTICLE_MODAL = 'TOGGLE_ARTICLE_MODAL';
export const SET_ARTICLE = 'SET_ARTICLE';
export const FETCH_MLT_DATA = 'FETCH_MLT_DATA';
export const FETCH_MLT_DATA_SUCCESS = 'FETCH_MLT_DATA_SUCCESS';
export const TOGGLE_PREVIEW_MODAL = 'TOGGLE_PREVIEW_MODAL';
export const TOOGLE_SETTING_MODAL = 'TOOGLE_SETTING_MODAL';
export const CHANGE_SETTING_MODAL = 'CHANGE_SETTING_MODAL';
export const MODIFY_CODING_MEDIA = 'MODIFY_CODING_MEDIA';
export const TOOGEL_QC_MODAL = 'TOOGEL_QC_MODAL';
export const TOOGEL_TESTING_MODAL = 'TOOGEL_TESTING_MODAL';
export const FETCH_COMMENT = 'FETCH_COMMENT';
export const FETCH_COMMENT_SUCCESS = 'FETCH_COMMENT_SUCCESS';
export const SET_IS_READ = 'SET_IS_READ';

export const setIsRead = (data) => ({
  type: SET_IS_READ,
  data
})

export const toggleArticleModal = (data) => ({
  type: TOGGLE_ARTICLE_MODAL,
  data,
});

export const setArticle = (data) => ({
  type: SET_ARTICLE,
  data,
});

export const fetchMltData = (data) => ({
  type: FETCH_MLT_DATA,
  data
})

export const fetchMltDataSuccess = (data) => ({
  type: FETCH_MLT_DATA_SUCCESS,
  data
})

export const togglePreviewModal = (data) => ({
  type: TOGGLE_PREVIEW_MODAL,
});

export const toggleSettingModal = (data) => ({
  type: TOOGLE_SETTING_MODAL,
  data,
})

export const changeSettingModal = (data) => ({
  type: CHANGE_SETTING_MODAL,
  data,
})

export const modifyCodingMedia = (data) => ({
  type: MODIFY_CODING_MEDIA,
  data,
})

export const toggleQcModal = (data) => ({
  type: TOOGEL_QC_MODAL,
  data,
})

export const toggleTestingModal = (data) => ({
  type: TOOGEL_TESTING_MODAL,
  data,
})

export const fetchComment = (data) => ({
  type: FETCH_COMMENT,
  data
})

export const fetchCommentSuccess = (data) => ({
  type: FETCH_COMMENT_SUCCESS,
  data
})



/** WEBPACK FOOTER **
 ** ./src/app/modules/modal/actions.js
 **/